import React, { useEffect, useMemo, useState } from "react";
import TableComponent from "../../../components/Table/TableComponent";
import APICall, {
  explodeDataWithRowTable,
} from "../../../components/Api/APICall";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { TableCellAmountFormate } from "./../../CommanApiFunction";
import FormWizard from "../../../components/Form/FormWizard";
import CommunEditModal from "../../../components/Modal/CommunEditModal";
import { isPattern } from "@formiz/validations";
import { useForm } from "@formiz/core";

export default function UDharPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [DataList, setDataList] = useState({
    row: [],
    dataWithRows: [],
    onlyData: [],
  });
  const [ShowEditModal, setShowEditModal] = useState(false);
  const [EditData, setEditData] = useState({});
  const tableHenders = [
    {
      accessor: "invoice_id",
      Header: "Invoice",
      Cell: (row) => TableCellAmountFormate(row, "text-green-600", false),
    },
    {
      accessor: "total",
      Header: "Total(₹)",
      Cell: (row) => TableCellAmountFormate(row, "text-orange-400"),
    },
    {
      accessor: "udhar",
      Header: "Udhar(₹)",
      Cell: (row) => TableCellAmountFormate(row, "text-red-800"),
    },
    {
      accessor: "recived_amount",
      Header: "RecivedAmount(₹)",
      Cell: (row) => TableCellAmountFormate(row, "text-green-900"),
    },
    {
      accessor: "name",
      Header: "CustomerName",
    },
    {
      accessor: "contact",
      Header: "contact",
    },
    {
      accessor: "adddate",
      Header: "Date",
    },
    {
      accessor: "other",
      Header: "Others Data",
    },
  ];

  const UpdateItemHandler = (row) => {
    setShowEditModal(true);
    setEditData(row);
  };
  const DataListAPiCall = () => {
    APICall(`/service/udharList`).then((data) => {
      if (data.status) {
        let newData = [];
        if (data.message.length > 0) {
          newData = data.message.map((item) => ({
            ...item,
            udhar: item.recived_amount - item.total,
            adddate: dayjs(item.adddate).format("DD-MM-YYYY"),
            other: (
              <button
                onClick={() => UpdateItemHandler(item)}
                className="bg-blue-500 text-white active:bg-indigo-600 text-xs font-bold uppercase px-3 py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
              >
                Update
              </button>
            ),
          }));
        }
        setIsLoading(false);
        explodeDataWithRowTable(newData, setDataList);
      } else {
        setIsLoading(false);
        toast.error(data.message);
      }
    });
  };

  useEffect(() => {
    DataListAPiCall();
  }, []);
  const myForm = useForm();

  const inptFildes = useMemo(
    () => [
      {
        title: "Recive Amount",
        fileds: [
          {
            name: "amount",
            label: "Recive Amount",
            required: "Recive Amount is required",
            type: "text",
            validations: [
              {
                rule: isPattern("^[0-9]*$"),
                message: "only Number value allowed",
              },
              // {
              //   rule: isMaxNumber(
              //     parseInt(EditData.total) - parseInt(EditData.recived_amount)
              //   ),
              //   message: `Max ${
              //     parseInt(EditData.total) - parseInt(EditData.recived_amount)
              //   } Amount is pending in ${EditData.invoice_id} invoice `,
              // },
            ],
          },
        ],
      },
    ],
    [EditData]
  );
  const editFormSubmit = (values) => {
    setIsLoading(true);
    values.invoice = EditData.customer_id;
    values.amount= parseInt(values.amount)+(EditData.recived_amount);
    APICall(`/service/UpdateUdharAmount`, "POST",values).then((data) => {
      if (data.status) {
        setIsLoading(false);
        setShowEditModal(false);
        DataListAPiCall();
      } else {
        setIsLoading(false);
        toast.error(data.message);
      }
    });
  };
  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <TableComponent
          columns={tableHenders}
          data={DataList.dataWithRows}
          selectOption={{ show: false }}
          pagination={true}
          exportData={true}
          TicketsTitle={`Udhar User list View`}
        />
        <CommunEditModal
          showModal={ShowEditModal}
          setShowModal={setShowEditModal}
          Title={`Update Amount (${EditData.invoice_id})  ₹${parseInt(
            EditData.total
          ).toFixed(2)}`}
        >
          <FormWizard
            inputes={inptFildes}
            showStep={false}
            isLoading={isLoading}
            submitForm={editFormSubmit}
            myForm={myForm}
          />
        </CommunEditModal>
      </div>
    </>
  );
}
